module.exports = __webpack_public_path__ + "img/no-list-open.e5ae57f3.svg";